<template>
  <div class="editionButtonsContainer float-right">
    <button
      v-b-tooltip.hover
      :class="{ activeButton: selectedSection == editionEditModes.editDetails }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Editionsdetails"
      type="button"
      @click="modeChange(editionEditModes.editDetails)"
    >
      <i class="fas fa-file-alt" />
    </button>
    <button
      v-b-tooltip.hover
      :class="{ activeButton: selectedSection == editionEditModes.editCantons }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Kanton-Bezirk-PLZ"
      type="button"
      @click="modeChange(editionEditModes.editCantons)"
    >
      <i class="fas fa-shield-alt" />
    </button>

    <button
      v-b-tooltip.hover
      :class="{
        activeButton: selectedSection == editionEditModes.editNogaBranches,
      }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="NOGA-Branchen"
      type="button"
      @click="modeChange(editionEditModes.editNogaBranches)"
    >
      <i class="fas fa-stream" />
    </button>
    <button
      v-b-tooltip.hover
      :class="{ activeButton: selectedSection == editionEditModes.editLinks }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Links"
      type="button"
      @click="modeChange(editionEditModes.editLinks)"
    >
      <i class="fas fa-link" />
    </button>
    <button
      v-b-tooltip.hover
      :class="{
        activeButton: selectedSection == editionEditModes.editAttatchments,
      }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Anlagen"
      type="button"
      @click="modeChange(editionEditModes.editAttatchments)"
    >
      <i class="fas fa-paperclip" />
    </button>

    <button
      v-b-tooltip.hover
      :class="{
        activeButton: selectedSection == editionEditModes.editCriterions,
      }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Klauseln verwalten"
      type="button"
      @click="modeChange(editionEditModes.editCriterions)"
    >
      <i class="fas fa-scroll" />
    </button>

    <button
      v-b-tooltip.hover
      :class="{
        activeButton: selectedSection == editionEditModes.editLanguages,
      }"
      class="btn btn-secondary mt-4 mr-1"
      placement="bottom"
      title="Übersetzungen"
      type="button"
      @click="modeChange(editionEditModes.editLanguages)"
    >
      <i class="fas fa-language" />
    </button>
    <!-- 
    <router-link 
      :to="`/contract-overview/${contractId}/${versionId}/${editionId}/mindestlohnkonfiguration/eingabemaske`"
    > -->
    <button
      v-b-tooltip.hover
      class="btn btn-secondary mt-4"
      placement="bottom"
      title="Mindestlohn-Rechner konfigurieren"
      type="button"
      @click="modeChange(editionEditModes.minimumWageConfigurations)"
    >
      <i class="fas fa-calculator" />
      <div class="externalLinkSymbol">
        <i class="fas fa-external-link-square-alt" />
      </div>
    </button>
    <!-- </router-link> -->
  </div>
</template>

<script>
import { UniaGAVConstants } from "@/assets/configuration/constants.js";

export default {
  props: {
    selectedSection: {
      type: String,
      default: "",
    },
    contractId: {
      type: String,
      default: "0",
    },
    versionId: {
      type: [String, Number],
      default: 0,
    },
    editionId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      editionEditModes: UniaGAVConstants.EditionEditModes,
    };
  },
  methods: {
    modeChange(newMode) {
      this.$emit("modeChanged", newMode);
    },
  },
};
</script>

<style scoped>
.editionButtonsContainer button {
  font-size: 16px;
}

.activeButton {
  background-color: #17a2b8;
}

.externalLinkSymbol {
  position: relative;
  color: red;
  top: -10px;
  left: 14px;
  font-size: 14px;
  height: 0px;
}
</style>
